/* script */
//
//
//
//

// Utils
import { isFunction } from 'lodash';

/**
 * Simple component used to display badges with optional action and tooltip.
 *
 * @vue-prop {Object} [config={}]
 * @vue-prop {String} [config.tooltip] an i18n message key to display on the tooltip.
 * @vue-prop {boolean} [config.emit] a boolean to tell the badge to propagate the click
 * @vue-prop {Function} [config.action] a function to perform when clicked.
 * @vue-prop {Array<String>} [config.classes] additional classes to add to the badge
 *
 * @category ui.components
 * @exports Badge
 * @component
 */
const __vue_script__ = {
    name: 'Badge',

    props: {
        config: {
            type: Object,
            default() {
                return {};
            }
        },
        stopClick: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            classes: '',
            tooltip: undefined
        };
    },

    watch: {
        config() {
            this.init();
        }
    },

    created() {
        this.init();
    },

    methods: {
        /**
         * Initialize the badge based on the configuration
         */
        init() {
            if (!this.config) return;

            if (this.config.tooltip) {
                this.tooltip = {
                    content: this.$i18n.t(this.config.tooltip),
                    placement: 'bottom',
                    delay: { show: 500, hide: 100 }
                };
            }

            const classes = this.config.classes || [];

            if (this.config.action) {
                classes.push('has-action');
            }

            this.classes = classes.join(' ');
        },

        /**
         * If an action is configured, this method executes it when the badge
         * is clicked.
         */
        action(event) {
            if (this.stopClick) {
                event.stopPropagation();
            }
            if (!this.config) {
                return;
            }
            if (isFunction(this.config.action)) {
                this.config.action();
            }
            if (this.config.emit) {
                this.$emit('badge-click', event);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tooltip",
          rawName: "v-tooltip",
          value: _vm.tooltip,
          expression: "tooltip",
        },
      ],
      staticClass: "badge",
      class: _vm.classes,
      on: {
        click: [
          function ($event) {
            $event.preventDefault()
            return _vm.action.apply(null, arguments)
          },
          function ($event) {
            return _vm.$emit("click")
          },
        ],
      },
    },
    [_vm._t("default")],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/Badge.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__